export enum MedicalHistoryGroups {
  Vaccinations = 1,
  FleaTickAndHeartwormMedications = 2,
  MedicationsAndOTCs = 3,
  Injectables = 4,
  Radiographs = 5,
  Ultrasounds = 6,
  Dentistry = 7,
  Immobilization = 8,
  SurgeryAndAnesthesia = 9,
  Labs = 10,
}
